module.exports = __webpack_public_path__ + "media/icons/offer-details-osobowe-58a6f256.png";